<script>
  import ImageAttachmentDisplay from './image-attachment-display.svelte';
</script>

<div class="cs-file-attachment-display">
  <ImageAttachmentDisplay />
</div>
<style lang="scss">
  @use './../../scss/components/file-attachment-display';
</style>
